const SECTIONS_DATA = [
  {
    title: 'Card 0',
    // imageUrl: `https://duskbreakers.gg/breaker_images/${id}.png`,
    id: 0,
    title0: 'Span 0',
    title1: 'Collection 0',
    title2: '12.3 AVAX',
    title3: '($10.15)',
  },
  {
    title: 'Card 1',
    imageUrl: 'https://via.placeholder.com/180',
    id: 1,
    title0: 'Span 0',
    title1: `xStartUp Epic NFT's Series Collection`,
    title2: '12.3 AVAX',
    title3: '($10.15)',
  },
  {
    title: 'Card 2',
    imageUrl: 'https://via.placeholder.com/180',
    id: 2,
    title0: 'Span 0',
    title1: 'Collection 2',
    title2: '12.3 AVAX',
    title3: '($10.15)',
  },
  {
    title: 'Card 3',
    imageUrl: 'https://via.placeholder.com/180',
    id: 3,
    title0: 'Span 0',
    title1: 'Collection 3',
    title2: '12.3 AVAX',
    title3: '($10.15)',
  },
  {
    title: 'Card 4',
    imageUrl: 'https://via.placeholder.com/180',
    id: 4,
    title0: 'Span 0',
    title1: 'Collection 4',
    title2: '12.3 AVAX',
    title3: '($10.15)',
  },
  {
    title: 'Card 5',
    imageUrl: 'https://via.placeholder.com/180',
    id: 5,
    title0: 'Span 0',
    title1: 'Collection 5',
    title2: '12.3 AVAX',
    title3: '($10.15)',
  },
  {
    title: 'Card 6',
    imageUrl: 'https://via.placeholder.com/180',
    id: 6,
    title0: 'Span 0',
    title1: 'Collection 6',
    title2: '12.3 AVAX',
    title3: '($10.15)',
  },
  {
    title: 'Card 7',
    imageUrl: 'https://via.placeholder.com/180',
    id: 7,
    title0: 'Span 0',
    title1: 'Collection 7',
    title2: 'Span 2',
    title3: 'Span 3',
  },
  {
    title: 'Card 8',
    imageUrl: 'https://via.placeholder.com/180',
    id: 8,
    title0: 'Span 0',
    title1: 'Collection 8',
    title2: 'Span 2',
    title3: 'Span 3',
  },

  {
    title: 'Card 9',
    imageUrl: 'https://via.placeholder.com/180',
    id: 9,
    title0: 'Span 0',
    title1: 'Collection 9',
    title2: 'Span 2',
    title3: 'Span 3',
  },
  {
    title: 'Card 10',
    imageUrl: 'https://via.placeholder.com/180',
    id: 10,
    title0: 'Span 0',
    title1: 'Collection 10',
    title2: 'Span 2',
    title3: 'Span 3',
  },
  {
    title: 'Card 11',
    imageUrl: 'https://via.placeholder.com/180',
    id: 11,
    title0: 'Span 0',
    title1: 'Collection 11',
    title2: 'Span 2',
    title3: 'Span 3',
  },
  {
    title: 'Card 12',
    imageUrl: 'https://via.placeholder.com/180',
    id: 12,
    title0: 'Span 0',
    title1: 'Collection 12',
    title2: 'Span 2',
    title3: 'Span 3',
  },
]

export default SECTIONS_DATA
